<template>
    <v-container fluid>
        <v-layout
            row
            wrap
        >
            <v-flex xs12>
                <v-card flat>
                    <v-card-title
                        primary-title
                        class="display-1"
                    >
                        {{ 'My shipping addresses' | translation }}
                    </v-card-title>
                </v-card>
            </v-flex>

            <v-flex
                xs12
                v-for="(address, index) in addresses"
                :key="index"
            >
                <v-card flat>
                    <v-layout>
                        <v-flex xs11>
                            <v-card-title primary-title>
                                <div>
                                    <div class="title">{{ "Shipping address" | translation }} {{ ++index }}</div>
                                    <div>{{ $order.getShippingAddressString(address)}}</div>
                                    <a
                                        href="#"
                                        color="primary"
                                        @click.prevent="editAddress(address)"
                                    >{{ 'Edit' | translation }}</a>
                                </div>
                            </v-card-title>
                        </v-flex>
                        <v-flex
                            xs1
                            ma-auto
                        >
                            <span>
                                <v-icon
                                    large
                                    color="primary"
                                    @click="deleteAddressClick(address)"
                                >delete</v-icon>
                            </span>
                        </v-flex>
                    </v-layout>
                </v-card>
            </v-flex>
            <v-flex
                xs12
                class="text-xs-right"
            >
                <v-btn
                    color="primary"
                    @click.prevent="editAddress()"
                >
                    {{ 'Create new address' | translation }}
                </v-btn>
            </v-flex>
            <v-flex
                xs-12
                v-if="showEditForm"
            >
                <shipping-address ref="form" prevent-load show-agb />
                <v-flex
                    xs12
                    class="text-xs-right"
                >
                    <v-btn color="primary" @click="saveAddressClick()">
                        {{ 'Save' | translation }}
                    </v-btn>
                </v-flex>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import ShippingAddress from '@breakmedia/prime-vue-checkout/src/AddressStep/ShippingAddress';

const moduleName = 'Profile';

export default {
    name: moduleName,
    components: {
        ShippingAddress,
    },
    data() {
        return {
            showEditForm: false,
        };
    },
    mounted() {
        this.loadAddress(false);
    },
    computed: {
        ...mapState('ShippingAddressForm', ['addresses']),
        shippingAddressComponent() {
            let country = this.$country.getCountry();
            if (Vue.options.components['checkout-shipping-address-' + country.toLowerCase()]) {
                return Vue.options.components['checkout-shipping-address-' + country.toLowerCase()];
            } else {
                return Vue.options.components['checkout-shipping-address-default'];
            }
        },
    },
    methods: {
        ...mapActions('ShippingAddressForm', ['loadAddress', 'saveAddress', 'deleteAddress']),
        ...mapMutations('ShippingAddressForm', ['setAddress', 'resetAddress']),
        editAddress(address = null) {
            if (address !== null) {
                this.setAddress(address);
            }
            this.showEditForm = true;
            if (address === null) {
                this.resetAddress();
                if (this.$refs.form) {
                    this.$refs.form.$refs.form.resetValidation();
                }
            }
        },
        saveAddressClick() {
            if (this.$refs.form.$refs.form.validate()) {
                this.saveAddress().then(() => {
                    this.showEditForm = false;
                    this.loadAddress(false);
                });
            }
        },
        deleteAddressClick(address) {
            this.deleteAddress(address).then(result => {
                if (result) {
                    this.loadAddress(false);    
                }
            });
        },
    },
};
</script>